import React, { useState, useEffect } from 'react';
import { Cookie, X, Settings } from 'lucide-react';

const CookieConsent = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // Check if user has already made a cookie choice
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      // Show popup after a short delay to not interrupt initial page load
      const timer = setTimeout(() => {
        setShowPopup(true);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowPopup(false);
  };

  const handleRejectAll = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setShowPopup(false);
  };

  const handleCustomize = () => {
    // Redirect to cookies policy page for detailed settings
    window.location.href = '/cookies-policy';
  };

  if (!showPopup) return null;

  return (
    <div className="fixed bottom-4 right-4 z-40 max-w-sm">
      <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-4">
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0">
            <Cookie className="h-6 w-6 text-book-brown" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-sm font-semibold text-gray-900 mb-1">
              Cookie Preferences
            </h3>
            <p className="text-xs text-gray-600 mb-3">
              We use cookies to enhance your experience. Manage your preferences or learn more in our{' '}
              <a
                href="/cookies-policy"
                data-discover="true"
                className="text-book-brown hover:underline"
              >
                Cookies Policy
              </a>.
            </p>
            <div className="flex space-x-2">
              <button
                onClick={handleAcceptAll}
                className="text-xs bg-book-brown text-white px-3 py-1.5 rounded hover:bg-book-brown-light transition-colors duration-200"
              >
                Accept All
              </button>
              <button
                onClick={handleRejectAll}
                className="text-xs bg-gray-200 text-gray-700 px-3 py-1.5 rounded hover:bg-gray-300 transition-colors duration-200"
              >
                Reject All
              </button>
              <button
                onClick={handleCustomize}
                className="text-xs bg-white border border-gray-300 text-gray-700 px-3 py-1.5 rounded hover:bg-gray-50 transition-colors duration-200"
              >
                <Settings className="h-3 w-3 inline mr-1" />
                Settings
              </button>
            </div>
          </div>
          <button
            onClick={() => setShowPopup(false)}
            className="flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors duration-200"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
